var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagazine = function SvgMagazine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.125V4.712m0 17.413S10.543 19.4 2.25 19.288a.515.515 0 0 1-.5-.519V2.394c0-.138.054-.271.152-.369a.5.5 0 0 1 .366-.15C10.545 1.985 13 4.712 13 4.712m0 17.413s2.457-2.725 10.75-2.837a.515.515 0 0 0 .5-.519V2.394a.52.52 0 0 0-.152-.369.5.5 0 0 0-.366-.15C15.455 1.985 13 4.712 13 4.712m-3 6.468a21.3 21.3 0 0 0-5.26-1.055m5.26 5.25a21.3 21.3 0 0 0-5.26-1.055M16 11.18a21.3 21.3 0 0 1 5.26-1.055M16 15.375a21.3 21.3 0 0 1 5.26-1.055"
  })));
};
export default SvgMagazine;